import { useTranslation } from "react-i18next";

import { FOOTER_RIGHT_LINKS } from "../../constants";

import "./style.less";

const FooterRight = () => {
  const { t, i18n } = useTranslation(["footer"]);

  return (
    <div className="footer-right__content">
      <h3>{t("exploreShopeepay&Seamoney")}</h3>
      <div className="content__links">
        {FOOTER_RIGHT_LINKS(t, i18n.language).map((item) => {
          return (
            <a
              key={item.name}
              href={item.link}
              target="_blank"
              rel="noreferrer"
            >
              {item.name}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default FooterRight;
